import { render, staticRenderFns } from "./proof-point.vue?vue&type=template&id=77c137b6"
import script from "./proof-point.vue?vue&type=script&lang=js"
export * from "./proof-point.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports